// extracted by mini-css-extract-plugin
export default {"Wrapper":"InputOtp_Wrapper__C9d35"};